module.exports = __webpack_public_path__ + "h5/img/my_bg.5107ad8d.png";